<template v-if="telephoneMissing">

    <div class="v-modal-add-telephone">
        <v-modal
                @close="postpone()"
                :show="telephoneMissing && !isPostponed">

            <div class="v-modal-add-telephone__content">
                <div class="v-modal-add-telephone__message">
                    For å forbedre kommunikasjonen rundt bestillinger ber vi om at du legger inn telefonnummeret ditt
                </div>

                <div class="v-modal-add-telephone__input">
                    <v-input
                            v-model="telephoneNumber"
                            label="Telefonnummer"/>
                </div>

                <div class="v-modal-add-telephone__actions">
                    <div class="v-modal-add-telephone__submit">
                        <v-button
                                :disabled="telephoneNumber.length < 8"
                                :loading="sending"
                                label="Lagre"
                                @click="saveTelephone"/>
                    </div>
                </div>

            </div>

        </v-modal>
    </div>

</template>

<script>
  import axios from "axios"
  import apiMixin from "../mixins/apiMixin"
  import vModal from "./vModal"
  import vButton from "./vButton"
  import vInput from "./vInput"
  import { mapGetters, mapActions } from "vuex";

  // 30 min possible postpone delay
  let postponeInterval = 1000 * 60 * 30;



  export default {
    name: "v-modal-add-telephone",
    components: {
      vModal,
      vInput,
      vButton
    },
    mixins: [
     apiMixin.apiMixin
    ],
    props: {
      postponeInterval: { type: Number, default: postponeInterval }
    },
    data() {
      return {
        telephoneNumber: "",
        sending: false,
        error: false,
      }
    },
    methods: {
      ...mapActions([
        'setUser'
      ]),
      postpone() {
        let user = this.getUser;
        user.telephonePostponedTime = new Date().getTime();
        this.setUser(this.getUser)
      },
      saveTelephone() {
        var that = this;
        that.error = false;
        that.sending = true;
        axios.patch(process.env.VUE_APP_API_URL + "/users/me",
          { "telephone": that.telephoneNumber },
          that.apiHeaders
        ).then(function (response) {
          // success
          that.setUser(response.data);
        }).catch(function (error) {
          // error
          that.errors.telephone = true;
        }).finally(function () {
          // always
          that.sending = false;
        });
      },
    },
    computed: {
      ...mapGetters([
        'getUser'
      ]),

      timeSincePostponed() {
        let postponedTime = this.getUser.telephonePostponedTime;
        return (new Date().getTime() - postponedTime)
      },

      isPostponed() {
        let postponedTime = this.getUser.telephonePostponedTime;

        if (postponedTime > 0) {
          return this.timeSincePostponed < this.postponeInterval;
          return (new Date().getTime() - postponedTime) < this.postponeInterval
        }
      },

      telephoneMissing() {
        return (this.getUser.token.length && this.getUser.telephone.length < 3) ? true : false;
      },
    }
  }
</script>

<style lang="scss">

    .v-modal-add-telephone {

        &__input {
            padding-top: 1em;

        }
        &__actions {
            padding-top: 2em;
            display: flex;
            justify-content: center;
        }

    }


</style>